import { objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { FocusableProvider } from '@react-aria/focus';
import React, { useRef } from 'react';
import { useTooltipTrigger } from 'react-aria';
import { TooltipTriggerStateContext, TooltipContext } from 'react-aria-components';
import { useTooltipTriggerState } from 'react-stately';
import { Provider } from '../../utils/index.esm.js';

/**
 * TooltipTrigger wraps around a trigger element and a Tooltip. It handles opening and closing
 * the Tooltip when the user hovers over or focuses the trigger, and positioning the Tooltip
 * relative to the trigger.
 */
function TooltipTrigger(props) {
  var state = useTooltipTriggerState(props);
  var ref = useRef(null);
  var _useTooltipTrigger = useTooltipTrigger(props, state, ref),
    triggerProps = _useTooltipTrigger.triggerProps,
    tooltipProps = _useTooltipTrigger.tooltipProps;
  return /*#__PURE__*/React.createElement(Provider
  // eslint-disable-next-line react-perf/jsx-no-new-array-as-prop
  , {
    values: [[TooltipTriggerStateContext, state], [TooltipContext, _objectSpread2(_objectSpread2({}, tooltipProps), {}, {
      triggerRef: ref
    })]]
  }, /*#__PURE__*/React.createElement(FocusableProvider, _extends({}, triggerProps, {
    ref: ref
  }), props.children));
}

export { TooltipTrigger as default };
//# sourceMappingURL=tooltip-trigger.esm.js.map
